import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { get, map, filter, size, min, max } from "lodash";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { I18n } from "@aws-amplify/core";

import { formatDate } from "../../utils/date";
import { getLov } from "../../utils/lov";
import { getAttributeValue, getAttributeType } from "../../utils/profile";
import JsonViewerDialog from "./JsonViewerDialog";

const Attribute = (props) => {
  const { data, id, language, attributes, parentEventData = {} } = props;
  const [lov, setLov] = React.useState({});

  React.useEffect(() => {
    const fetchLov = async () => {
      setLov({
        [id]: await getLov(id),
      });
    };
    if (!get(lov, [id])) {
      fetchLov();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const attrName = map(
    filter(attributes, (attr) => attr.id === id),
    (attr) => attr[`name_${language}`]
  );

  const renderBooleanValue = (value) => {
    if (value === true) {
      return I18n.get("profiles_yes");
    } else if (value === false) {
      return I18n.get("profiles_no");
    }
    return "-";
  };

  const renderFloatValue = (value) => {
    if (value || value === 0) {
      return parseFloat(value).toFixed(2);
    }
    return "-";
  };

  const renderJsonAttribute = (value) => {
    return (
      <div style={{ maxWidth: "200px", maxHeight: "200px", overflow: "auto" }}>
        <JsonViewerDialog value={value} />
      </div>
    );
  };

  const render169 = () => {
    let thermalJson = JSON.parse(getAttributeValue(data, id));
    if (thermalJson) {
      thermalJson.samples = map(get(thermalJson, ["samples"]), (s) => ({
        ...s,
        roi: {
          ...s.roi,
          temp_map: `${size(get(s, ["roi", "temp_map"]))} entries, max=${max(
            get(s, ["roi", "temp_map"])
          )}, min=${min(get(s, ["roi", "temp_map"]))}`,
        },
      }));
      return JSON.stringify(thermalJson);
    }
    return "";
  };

  const getDateTime = id == 76 ? "created_on" : "end"
  const parentDateTime = [76, 77]

  return (
    <Grid item style={{ padding: "8px", ...props.style }}>
      <Box className={"text-87 bold-500"}>{attrName}</Box>
      <Box style={{ overflowWrap: "anywhere", marginBottom: "8px" }}>
        <span className="text-54">
          {id === 169
            ? render169() :
            parentDateTime.includes(id) ? get(parentEventData, [getDateTime]) ? formatDate(get(parentEventData, [getDateTime])) : "-"
              : getAttributeType(data, id) === "json"
                ? renderJsonAttribute(getAttributeValue(data, id))
                : getAttributeType(data, id) === "datetime"
                  ? formatDate(getAttributeValue(data, id))
                  : getAttributeType(data, id) === "boolean"
                    ? renderBooleanValue(getAttributeValue(data, id))
                    : getAttributeType(data, id) === "float"
                      ? renderFloatValue(getAttributeValue(data, id))
                      : getAttributeType(data, id) === "lov(picker)"
                        ? getAttributeValue(data, id, lov)
                        : getAttributeValue(data, id, lov, language) || "-"}
        </span>
      </Box>
    </Grid>
  );
};

Attribute.propTypes = {
  data: PropTypes.shape({
    attributes: PropTypes.array,
  }),
  id: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
    attributes: state.attributes,
  };
};

export default connect(mapStateToProps)(Attribute);
